export default __webpack_public_path__ + "static/media/battery_orange.e07055b3.svg";